export const NOT_SMALL_MEDIA_QUERY = 'screen and (min-width: 48em)';
export const MEDIUM_MEDIA_QUERY = `${NOT_SMALL_MEDIA_QUERY} and (max-width: 64em)`;
export const LARGE_MEDIA_QUERY = 'screen and (min-width: 64em)';
